module.exports = {"130823100":"平泉镇","130823101":"黄土梁子镇","130823102":"榆树林子镇","130823103":"杨树岭镇","130823104":"七沟镇","130823105":"小寺沟镇","130823106":"党坝镇","130823107":"卧龙镇","130823108":"南五十家子镇","130823109":"北五十家子镇","130823110":"桲椤树镇","130823111":"柳溪镇","130823200":"王土房乡","130823203":"七家岱满族乡","130823204":"平房满族蒙古族乡","130823206":"茅兰沟满族蒙古族乡","130823207":"台头山乡","130823209":"松树台乡","130823210":"道虎沟乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130823.json
// module id = 205
// module chunks = 0